module.exports = __webpack_public_path__ + "img/PLC-5.5da5d279.png";